module.exports = __webpack_public_path__ + "img/specials-slider-v-luxury-cjdr.d87e2d4e.png";